// extracted by mini-css-extract-plugin
export default {"author":"PostItem_author__sbdGu","avatarWrapper":"PostItem_avatarWrapper__u2BLW","username":"PostItem_username__7l1NU","dot":"PostItem_dot__AkeaW"};